export const SUPPORT_EXTERNAL = 'vue-support-external';
export const SUPPORT_PORTAL = 'vue-support-portal';